/// <amd-module name="Wit/Common/BacklogContent/Contracts/Contracts" />
export interface IWorkItemSelection {
    workItemId: number; 
    workItemType: string;
}
